import { Component, Inject, Input, OnInit } from '@angular/core';
import { BillService } from '../../bill.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import icClose from '@iconify/icons-ic/twotone-close';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';
import { GedService } from '../../../../admin/playground/docuware-playground/ged.service';
import { GED_CONFIG } from '../../../../../../core/enums/ged-type.enum';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'vex-bill-preview-modal',
  templateUrl: './bill-preview-modal.component.html',
  styleUrls: ['./bill-preview-modal.component.scss'],
})
export class BillPreviewModalComponent implements OnInit {
  url: SafeResourceUrl = null;
  ENUM_PERMISSION = ENUM_PERMISSIONS;
  loading = false;
  icClose = icClose;
  errorMessage;

  @Input() showToPayButton: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<BillPreviewModalComponent>,
    private sanitizer: DomSanitizer,
    private gedService: GedService,
  ) {}

  ngOnInit(): void {
    if (this.data?.showToPayButton) this.showToPayButton = this.data?.showToPayButton;
    this.loading = true;

    this.gedService.setUrl(GED_CONFIG.bill.apiUrl);
    this.gedService.downloadDocument(this.data.docuwareId).subscribe(
      (res: HttpResponse<Blob>) => {
        const blob = new Blob([res.body], { type: res.headers.get('content-type') || 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        this.loading = false;
      },
      error => {
        console.error(error);
        this.errorMessage = 'Impossible de charger le document';
        this.loading = false;
      },
    );
  }

  close(result: any = null) {
    this.dialogRef.close(result);
  }
}
